import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Formula Fields icon. Exported from Figma (Bombiix 2026). */
const FormulaFieldsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M4.87868 15.691C5.75736 16.6673 7.17157 16.6673 10 16.6673C12.8284 16.6673 14.2426 16.6673 15.1213 15.691C16 14.7147 16 13.1433 16 10.0007C16 6.85795 16 5.28661 15.1213 4.3103C14.2426 3.33398 12.8284 3.33398 10 3.33398C7.17157 3.33398 5.75736 3.33398 4.87868 4.3103C4 5.28661 4 6.85795 4 10.0007C4 13.1433 4 14.7147 4.87868 15.691Z"
      stroke="currentColor"
    />
    <path
      d="M6.66699 7.33333C6.66699 7.02334 6.66699 6.86835 6.70107 6.74118C6.79353 6.39609 7.06308 6.12654 7.40817 6.03407C7.53534 6 7.69033 6 8.00033 6H12.0003C12.3103 6 12.4653 6 12.5925 6.03407C12.9376 6.12654 13.2071 6.39609 13.2996 6.74118C13.3337 6.86835 13.3337 7.02334 13.3337 7.33333C13.3337 7.64332 13.3337 7.79832 13.2996 7.92549C13.2071 8.27058 12.9376 8.54013 12.5925 8.63259C12.4653 8.66667 12.3103 8.66667 12.0003 8.66667H8.00033C7.69033 8.66667 7.53534 8.66667 7.40817 8.63259C7.06308 8.54013 6.79353 8.27058 6.70107 7.92549C6.66699 7.79832 6.66699 7.64332 6.66699 7.33333Z"
      stroke="currentColor"
    />
    <circle cx="7.33366" cy="10.6667" r="0.666667" fill="currentColor" />
    <circle cx="7.33366" cy="13.3327" r="0.666667" fill="currentColor" />
    <circle cx="9.99967" cy="10.6667" r="0.666667" fill="currentColor" />
    <circle cx="9.99967" cy="13.3327" r="0.666667" fill="currentColor" />
    <circle cx="12.6667" cy="10.6667" r="0.666667" fill="currentColor" />
    <circle cx="12.6667" cy="13.3327" r="0.666667" fill="currentColor" />
  </svg>
);

export default FormulaFieldsIcon;
